import * as R from 'ramda';

export function leadCountsFromResults(results) {
    const aggPath = ['aggregations', 'new_or_reactivated', 'buckets'];
    return {
        new: R.path(R.concat(aggPath, ['new', 'doc_count']), results),
        reactivated: R.path(R.concat(aggPath, ['reactivated', 'doc_count']), results)
    };
}



// WEBPACK FOOTER //
// ./common/lead_search_helper.js